import { Directive, Input, AfterContentInit, ContentChildren, QueryList, Renderer2 } from '@angular/core';
import { FormControlName } from '@angular/forms';
import { PermissionService } from '../../core/services/common/permission.service';
import { BaseFieldPermissionDirective } from './base-field-permission.directive';
import { FieldPermissionStyleService } from '../services/field-permission-style.service';

@Directive({
  selector: '[appFormFieldPermissions]'
})
export class FormFieldPermissionsDirective extends BaseFieldPermissionDirective implements AfterContentInit {
  @ContentChildren(FormControlName) formControls!: QueryList<FormControlName>;
  
  constructor(
    permissionService: PermissionService, 
    private renderer: Renderer2,
    styleService: FieldPermissionStyleService
  ) {
    super(permissionService, styleService);
  }

  ngAfterContentInit() {
    if (this.permissionService.isAdminRole()) {
      return;
    }
    
    const fieldPermissions = this.permissionService.getFieldPermissions(this.pageTarget);
    if (!fieldPermissions || fieldPermissions.length === 0) {
      return;
    }
    
    this.formControls.forEach(control => {
      const fieldName = control.name as string;
      const element = this.getElementFromControl(control);
      
      if (element) {
        const { canView, canWrite } = this.checkFieldPermission(fieldName);
        
        if (canView && !canWrite) {
          this.applyReadonlyStyleToElement(element, this.renderer);
        } else if (!canView) {
          this.applyObfuscatedStyleToElement(element, this.renderer);
        }
      }
    });
  }
  
  private getElementFromControl(control: FormControlName): HTMLElement | null {
    try {
      if (control.valueAccessor) {
        const valueAccessor = control.valueAccessor as any;
        if (valueAccessor._elementRef && valueAccessor._elementRef.nativeElement) {
          return valueAccessor._elementRef.nativeElement;
        }
        if (valueAccessor._renderer && valueAccessor._renderer.element) {
          return valueAccessor._renderer.element;
        }
        
        if (valueAccessor.elementRef && valueAccessor.elementRef.nativeElement) {
          return valueAccessor.elementRef.nativeElement;
        }
      }
      
      const ngControl = control as any;
      if (ngControl._parent && ngControl._parent._element) {
        return ngControl._parent._element.nativeElement;
      }
      
      const formGroup = control.formDirective as any;
      if (formGroup && formGroup._element) {
        const formElement = formGroup._element.nativeElement;
        if (formElement) {
          const fieldName = control.name;
          let element = formElement.querySelector(`#${fieldName}`);
          if (!element) {
            element = formElement.querySelector(`[name="${fieldName}"]`);
          }
          if (!element) {
            element = formElement.querySelector(`[formControlName="${fieldName}"]`);
          }
          if (element) {
            return element;
          }
        }
      }
      return null;
    } catch (error) {
      console.error('Error getting element from control:', error);
      return null;
    }
  }
}
